import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className="footer_container">
        <p>2023 - Ⓒ - Sidhant Nahak</p>
    </div>
  )
}

export default Footer